var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _c(
      "div",
      { staticClass: "boss-main-wrap boss-main-content-wrap" },
      [
        _c("setting-header", {
          attrs: {
            breadcrumbs: [
              { name: "面接情報", pathName: "interviewInformationTop" },
            ],
            title: "面接情報_" + _vm.title,
          },
        }),
        _vm._v(" "),
        !_vm.isEdit ? _c("div", [_vm._m(0)]) : _vm._e(),
        _vm._v(" "),
        _c("div", [
          _c(
            "div",
            { staticClass: "boss-scout-send-container" },
            [
              _c("form-item", {
                attrs: {
                  "form-label-class-name": "pega-form-label-importance",
                  placeholder: "(例)事務用（20XX年度版)",
                },
                scopedSlots: _vm._u([
                  {
                    key: "label",
                    fn: function () {
                      return [_c("span", [_vm._v("登録名")])]
                    },
                    proxy: true,
                  },
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c("span", [
                          _vm._v(
                            "本画面内で管理に使う項目です。ユーザーサイトには表示されません。"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("small", [
                            _vm._v(
                              _vm._s(_vm.jobInterview.name.length) +
                                "文字/ 30文字"
                            ),
                          ]),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "error",
                    fn: function () {
                      return [
                        _vm.nameValidation.isShow
                          ? _c("validation-label", {
                              attrs: {
                                "data-test": "error-name",
                                label: _vm.nameValidation.message,
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.jobInterview.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.jobInterview, "name", $$v)
                  },
                  expression: "jobInterview.name",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "grid-x grid-padding-x grid-padding-y pega-form",
                },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "auto cell" }, [
                    _vm.publishedJobs.length === 0
                      ? _c(
                          "div",
                          { attrs: { "data-test": "no-published-jobs" } },
                          [
                            _vm._v(
                              "\n              設定できる求人がありません。\n            "
                            ),
                          ]
                        )
                      : _c(
                          "div",
                          [
                            _vm._m(2),
                            _vm._v(" "),
                            _vm._l(_vm.publishedJobs, function (option, i) {
                              return _c("div", { key: option.jobId }, [
                                _c("label", { staticClass: "boss-checkbox" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.jobInterview.jobs,
                                        expression: "jobInterview.jobs",
                                      },
                                    ],
                                    staticClass: "boss-input-checkbox",
                                    attrs: {
                                      type: "checkbox",
                                      "data-test": "option-jobs-" + i,
                                    },
                                    domProps: {
                                      checked: _vm.jobInterview.jobs.includes(
                                        option.jobId
                                      ),
                                      value: option.jobId,
                                      checked: Array.isArray(
                                        _vm.jobInterview.jobs
                                      )
                                        ? _vm._i(
                                            _vm.jobInterview.jobs,
                                            option.jobId
                                          ) > -1
                                        : _vm.jobInterview.jobs,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a = _vm.jobInterview.jobs,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = option.jobId,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.jobInterview,
                                                "jobs",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.jobInterview,
                                                "jobs",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.jobInterview,
                                            "jobs",
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      attrs: {
                                        "data-test": "option-job-label-" + i,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(option.jobAdministrationName) +
                                          "（ " +
                                          _vm._s(option.jobName) +
                                          " ）\n                  "
                                      ),
                                    ]
                                  ),
                                ]),
                              ])
                            }),
                          ],
                          2
                        ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "boss-joboffer-title boss-setting margin-top-2",
            attrs: { "data-test": "interview-information-title" },
          },
          [_vm._v("\n      概要\n    ")]
        ),
        _vm._v(" "),
        _c("div", [
          _c(
            "div",
            { staticClass: "boss-scout-send-container" },
            [
              _c("form-item-radio-with-text-area", {
                attrs: {
                  options: _vm.interviewOptions.paperScreenings,
                  "value-class-name":
                    "pega-badge-radio-text pega-badge-radio-check-mark",
                  placeholder:
                    "（例） 合否に関らず、3営業日以内にメッセージにてご連絡いたします。",
                  "max-character": 300,
                  remarks: _vm.jobInterview.paperScreeningRemarks,
                  "option-key-label": "paper-sreenings",
                },
                on: {
                  "update:remarks": function ($event) {
                    return _vm.$set(
                      _vm.jobInterview,
                      "paperScreeningRemarks",
                      $event
                    )
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "label",
                    fn: function () {
                      return [_c("span", [_vm._v("書類選考の有無")])]
                    },
                    proxy: true,
                  },
                  {
                    key: "error",
                    fn: function () {
                      return [
                        _vm.paperScreeningRemarksValidation.isShow
                          ? _c("validation-label", {
                              attrs: {
                                "data-test": "error-paper-sreenings",
                                label:
                                  _vm.paperScreeningRemarksValidation.message,
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.jobInterview.paperScreening.id,
                  callback: function ($$v) {
                    _vm.$set(_vm.jobInterview.paperScreening, "id", $$v)
                  },
                  expression: "jobInterview.paperScreening.id",
                },
              }),
              _vm._v(" "),
              _c("form-item-radio-with-text-area", {
                attrs: {
                  options: _vm.interviewOptions.spiTests,
                  "value-class-name":
                    "pega-badge-radio-text pega-badge-radio-check-mark",
                  placeholder: "(例）SPI検査（WEBテスト）を実施します。",
                  "max-character": 300,
                  remarks: _vm.jobInterview.spiTestRemarks,
                  "option-key-label": "spi-test",
                },
                on: {
                  "update:remarks": function ($event) {
                    return _vm.$set(_vm.jobInterview, "spiTestRemarks", $event)
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "label",
                    fn: function () {
                      return [_c("span", [_vm._v("適性検査の有無")])]
                    },
                    proxy: true,
                  },
                  {
                    key: "error",
                    fn: function () {
                      return [
                        _vm.spiRemarksValidation.isShow
                          ? _c("validation-label", {
                              attrs: {
                                "data-test": "error-spi-test",
                                label: _vm.spiRemarksValidation.message,
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.jobInterview.spiTest.id,
                  callback: function ($$v) {
                    _vm.$set(_vm.jobInterview.spiTest, "id", $$v)
                  },
                  expression: "jobInterview.spiTest.id",
                },
              }),
              _vm._v(" "),
              _c("form-item-text-area", {
                attrs: {
                  placeholder:
                    "（例） 弊社のビジョン「〇〇〇〇〇〇〇」に、共感していただける方からのご応募を、お待ちしております！\nご不安なことがありましたら、些細なことでもご相談下さい。",
                  "class-name":
                    "pega-interview-textarea-large pega-textarea-low pega-textarea-vertical",
                  "data-test": "message",
                },
                scopedSlots: _vm._u([
                  {
                    key: "label",
                    fn: function () {
                      return [
                        _c("span", [
                          _vm._v("応募する方への"),
                          _c("br"),
                          _vm._v("メッセージ"),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c("div", [
                          _c("small", [
                            _vm._v(
                              _vm._s(_vm.jobInterview.message.length) +
                                "文字/ 800文字"
                            ),
                          ]),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "error",
                    fn: function () {
                      return [
                        _vm.messageValidation.isShow
                          ? _c("validation-label", {
                              attrs: {
                                "data-test": "error-message",
                                label: _vm.messageValidation.message,
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.jobInterview.message,
                  callback: function ($$v) {
                    _vm.$set(_vm.jobInterview, "message", $$v)
                  },
                  expression: "jobInterview.message",
                },
              }),
            ],
            1
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "boss-main-wrap boss-main-content-wrap pega-interview-detail-background margin-top-2 padding-bottom-3",
      },
      [
        _c(
          "div",
          {
            staticClass: "boss-joboffer-title boss-setting margin-top-1",
            attrs: { "data-test": "interview-detail-title" },
          },
          [_vm._v("\n      詳細\n    ")]
        ),
        _vm._v(" "),
        _vm._m(3),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "boss-scout-send-container boss-bgcolor-white margin-top-0",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "grid-x grid-padding-x  pega-form pega-interview-form",
              },
              [
                _vm._m(4),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cell auto" },
                  [
                    _c("form-item-text-area", {
                      ref: "content",
                      attrs: {
                        placeholder:
                          "（例）面接の流れ、チェックポイント、雰囲気など",
                        "class-name":
                          "pega-interview-textarea-large pega-textarea-low pega-textarea-vertical",
                        "form-label-class-name": "pega-form-label-interview",
                        "data-test": "content",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [_c("span", [_vm._v("面接内容")])]
                          },
                          proxy: true,
                        },
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "boss-textarea-button" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "boss-button",
                                      attrs: { "data-test": "sample-text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.insertionValue()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  例文を挿入する\n                "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _c("small", [
                                  _vm._v(
                                    _vm._s(_vm.jobInterview.content.length) +
                                      "文字/ 500文字"
                                  ),
                                ]),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "error",
                          fn: function () {
                            return [
                              _vm.contentValidation.isShow
                                ? _c("validation-label", {
                                    attrs: {
                                      "data-test": "error-content",
                                      label: _vm.contentValidation.message,
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                      model: {
                        value: _vm.jobInterview.content,
                        callback: function ($$v) {
                          _vm.$set(_vm.jobInterview, "content", $$v)
                        },
                        expression: "jobInterview.content",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "grid-x grid-padding-x grid-padding-y pega-form pega-interview-form-top-none",
                      },
                      [
                        _vm._m(5),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "auto cell padding-top-0 padding-left-0 padding-right-0 interview-form-top-none",
                          },
                          [
                            _vm._l(
                              _vm.jobInterview.interviewers,
                              function (interviewer, i) {
                                return _c(
                                  "div",
                                  { key: i },
                                  [
                                    _c("interviewer", {
                                      attrs: {
                                        "selection-type":
                                          interviewer.selectionType.id,
                                        interviewer: interviewer,
                                        index: i + 1,
                                        gender: interviewer.gender.id,
                                        position: interviewer.position.id,
                                        generation: interviewer.generation.id,
                                        "remarks-or-free-text":
                                          interviewer.remarksOrFreeText,
                                      },
                                      on: {
                                        "update:selectionType": function (
                                          $event
                                        ) {
                                          return _vm.$set(
                                            interviewer.selectionType,
                                            "id",
                                            $event
                                          )
                                        },
                                        "update:selection-type": function (
                                          $event
                                        ) {
                                          return _vm.$set(
                                            interviewer.selectionType,
                                            "id",
                                            $event
                                          )
                                        },
                                        "update:gender": function ($event) {
                                          return _vm.$set(
                                            interviewer.gender,
                                            "id",
                                            $event
                                          )
                                        },
                                        "update:position": function ($event) {
                                          return _vm.$set(
                                            interviewer.position,
                                            "id",
                                            $event
                                          )
                                        },
                                        "update:generation": function ($event) {
                                          return _vm.$set(
                                            interviewer.generation,
                                            "id",
                                            $event
                                          )
                                        },
                                        "update:remarksOrFreeText": function (
                                          $event
                                        ) {
                                          return _vm.$set(
                                            interviewer,
                                            "remarksOrFreeText",
                                            $event
                                          )
                                        },
                                        "update:remarks-or-free-text":
                                          function ($event) {
                                            return _vm.$set(
                                              interviewer,
                                              "remarksOrFreeText",
                                              $event
                                            )
                                          },
                                        delete: function ($event) {
                                          return _vm.deleteInterviewer(i)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }
                            ),
                            _vm._v(" "),
                            _vm.isAbleToAddInterviewers()
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "boss-button boss-button-new  margin-left-1 ",
                                    attrs: { "data-test": "add-interviewer" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addInterviewer()
                                      },
                                    },
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "boss-icon-new",
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "boss-button-new-text" },
                                      [_vm._v("選考を追加する")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("form-item-radio-with-text-area", {
                      attrs: {
                        options: _vm.interviewOptions.requiredTimes,
                        "value-class-name":
                          "pega-badge-radio-text pega-badge-radio-check-mark",
                        placeholder:
                          "（例）会社説明+面接のトータル時間となります。",
                        "max-character": 300,
                        remarks: _vm.jobInterview.requiredTimeRemarks,
                        "option-key-label": "required-time",
                        "is-optional": true,
                        "form-label-class-name": "pega-form-label-interview",
                      },
                      on: {
                        "update:remarks": function ($event) {
                          return _vm.$set(
                            _vm.jobInterview,
                            "requiredTimeRemarks",
                            $event
                          )
                        },
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("span", [
                                _vm._v("所要時間"),
                                _c("small", [_vm._v("（任意）")]),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "suffix",
                          fn: function () {
                            return [_c("span", [_vm._v("程度")])]
                          },
                          proxy: true,
                        },
                        {
                          key: "error",
                          fn: function () {
                            return [
                              _vm.requiredTimeRemarksValidation.isShow
                                ? _c("validation-label", {
                                    attrs: {
                                      "data-test":
                                        "error-required-time-remarks",
                                      label:
                                        _vm.requiredTimeRemarksValidation
                                          .message,
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                      model: {
                        value: _vm.jobInterview.requiredTime.id,
                        callback: function ($$v) {
                          _vm.$set(_vm.jobInterview.requiredTime, "id", $$v)
                        },
                        expression: "jobInterview.requiredTime.id",
                      },
                    }),
                    _vm._v(" "),
                    _c("form-item-radio-with-text-area", {
                      attrs: {
                        options: _vm.interviewOptions.clothes,
                        "value-class-name":
                          "pega-badge-radio-text pega-badge-radio-check-mark",
                        placeholder:
                          "（例）筆記用具のご用意をお願いいたします。",
                        "max-character": 300,
                        remarks: _vm.jobInterview.clothRemarks,
                        "option-key-label": "cloth",
                        "is-optional": true,
                        "form-label-class-name": "pega-form-label-interview",
                        "form-class-name": "pega-interview-form-bottom-none",
                      },
                      on: {
                        "update:remarks": function ($event) {
                          return _vm.$set(
                            _vm.jobInterview,
                            "clothRemarks",
                            $event
                          )
                        },
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("span", [
                                _vm._v("面接時の服装／持ち物"),
                                _c("small", [_vm._v("（任意）")]),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "error",
                          fn: function () {
                            return [
                              _vm.clothRemarksValidation.isShow
                                ? _c("validation-label", {
                                    attrs: {
                                      "data-test": "error-cloth-remarks",
                                      label: _vm.clothRemarksValidation.message,
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                      model: {
                        value: _vm.jobInterview.cloth.id,
                        callback: function ($$v) {
                          _vm.$set(_vm.jobInterview.cloth, "id", $$v)
                        },
                        expression: "jobInterview.cloth.id",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "grid-x grid-padding-x  pega-form pega-interview-form",
              },
              [
                _vm._m(6),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cell auto" },
                  [
                    _c("form-item-rating", {
                      attrs: {
                        rating: _vm.jobInterview.businessManner,
                        label: "ビジネスマナー",
                        "form-label-class-name": "pega-form-label-interview",
                      },
                      on: {
                        "update:rating": function ($event) {
                          return _vm.$set(
                            _vm.jobInterview,
                            "businessManner",
                            $event
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("form-item-rating", {
                      attrs: {
                        rating: _vm.jobInterview.communicationAbility,
                        label: "コミュニケーション能力",
                        "form-label-class-name": "pega-form-label-interview",
                      },
                      on: {
                        "update:rating": function ($event) {
                          return _vm.$set(
                            _vm.jobInterview,
                            "communicationAbility",
                            $event
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("form-item-rating", {
                      attrs: {
                        rating: _vm.jobInterview.skill,
                        label: "過去の経験・スキル",
                        "form-label-class-name": "pega-form-label-interview",
                      },
                      on: {
                        "update:rating": function ($event) {
                          return _vm.$set(_vm.jobInterview, "skill", $event)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("form-item-rating", {
                      attrs: {
                        rating: _vm.jobInterview.motivation,
                        label: "やる気",
                        "form-label-class-name": "pega-form-label-interview",
                        "form-class-name": "pega-interview-form-bottom-none",
                      },
                      on: {
                        "update:rating": function ($event) {
                          return _vm.$set(
                            _vm.jobInterview,
                            "motivation",
                            $event
                          )
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "grid-x grid-padding-x  pega-form pega-interview-form",
              },
              [
                _vm._m(7),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cell auto" },
                  [
                    _c("form-item-text-area", {
                      attrs: {
                        placeholder:
                          "（例）仕事をする上で重視していることは何ですか？",
                        "form-label-class-name": "pega-form-label-interview",
                        "class-name":
                          "pega-textarea-low pega-textarea-vertical",
                        "data-test": "question1",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [_c("span", [_vm._v("過去の質問例１")])]
                          },
                          proxy: true,
                        },
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c("div", [
                                _c("small", [
                                  _vm._v(
                                    _vm._s(_vm.jobInterview.question1.length) +
                                      "文字/ 300文字"
                                  ),
                                ]),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "error",
                          fn: function () {
                            return [
                              _vm.question1Validation.isShow
                                ? _c("validation-label", {
                                    attrs: {
                                      "data-test": "error-question1",
                                      label: _vm.question1Validation.message,
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                      model: {
                        value: _vm.jobInterview.question1,
                        callback: function ($$v) {
                          _vm.$set(_vm.jobInterview, "question1", $$v)
                        },
                        expression: "jobInterview.question1",
                      },
                    }),
                    _vm._v(" "),
                    _c("form-item-text-area", {
                      attrs: {
                        placeholder:
                          "（例）5年後、10年後の自分はどうなっていたいですか？",
                        "form-label-class-name": "pega-form-label-interview",
                        "class-name":
                          "pega-textarea-low pega-textarea-vertical",
                        "data-test": "question2",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("span", [
                                _vm._v("過去の質問例２"),
                                _c("small", [_vm._v("（任意）")]),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c("div", [
                                _c("small", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.jobInterview.question2
                                        ? _vm.jobInterview.question2.length
                                        : 0
                                    ) + "文字/ 300文字"
                                  ),
                                ]),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "error",
                          fn: function () {
                            return [
                              _vm.question2Validation.isShow
                                ? _c("validation-label", {
                                    attrs: {
                                      "data-test": "error-question2",
                                      label: _vm.question2Validation.message,
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                      model: {
                        value: _vm.jobInterview.question2,
                        callback: function ($$v) {
                          _vm.$set(_vm.jobInterview, "question2", $$v)
                        },
                        expression: "jobInterview.question2",
                      },
                    }),
                    _vm._v(" "),
                    _c("form-item-text-area", {
                      attrs: {
                        placeholder: "（例）入社可能時期はいつですか？",
                        "max-character": 300,
                        "form-label-class-name": "pega-form-label-interview",
                        "class-name":
                          "pega-textarea-low pega-textarea-vertical",
                        "data-test": "question3",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("span", [
                                _vm._v("過去の質問例３"),
                                _c("small", [_vm._v("（任意）")]),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c("div", [
                                _c("small", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.jobInterview.question3
                                        ? _vm.jobInterview.question3.length
                                        : 0
                                    ) + "文字/ 300文字"
                                  ),
                                ]),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "error",
                          fn: function () {
                            return [
                              _vm.question3Validation.isShow
                                ? _c("validation-label", {
                                    attrs: {
                                      "data-test": "error-question3",
                                      label: _vm.question3Validation.message,
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                      model: {
                        value: _vm.jobInterview.question3,
                        callback: function ($$v) {
                          _vm.$set(_vm.jobInterview, "question3", $$v)
                        },
                        expression: "jobInterview.question3",
                      },
                    }),
                    _vm._v(" "),
                    _c("interview-information-welcome-question", {
                      attrs: {
                        options: _vm.interviewOptions.welcomeQuestionsOptions,
                        "form-label-class-name": "pega-form-label-interview",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("span", [
                                _vm._v("歓迎する質問"),
                                _c("small", [_vm._v("（任意）")]),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c("span", [
                                _vm._v(
                                  "応募者からの質問で、面接時に回答可能な項目がありましたらチェックをお願いいたします。"
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                      model: {
                        value: _vm.jobInterview.welcomeQuestions,
                        callback: function ($$v) {
                          _vm.$set(_vm.jobInterview, "welcomeQuestions", $$v)
                        },
                        expression: "jobInterview.welcomeQuestions",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "boss-main-wrap boss-main-content-wrap" },
      [
        _c(
          "form-button-area",
          [
            _c("form-confirm-button", {
              attrs: {
                "is-disabled": _vm.hasErrors,
                "submit-label": "登録内容を確認する",
                "data-test": "confirm-button",
              },
              on: { "submit-event": _vm.onConfirmClick },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "align-justify", attrs: { "data-test": "notification" } },
      [
        _c("p", { staticClass: "margin-bottom-0" }, [
          _vm._v("ユーザーサイトに掲載する内容を登録します。"),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "boss-text margin-top-0 margin-bottom-1" }, [
          _vm._v(
            "\n          個人情報や誹謗中傷など公序良俗に反する内容は記載しないようご注意ください。トラブルが発生した場合、当社では一切責任を負いかねます。\n        "
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "medium-3 cell pega-form-label pega-form-label-importance",
        attrs: { "data-test": "form-label" },
      },
      [_c("span", [_vm._v("求人設定")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pega-mb-05" }, [
      _c("span", { staticClass: "boss-text font-bold" }, [
        _vm._v(
          "公開する求人を選択してください。※未選択の場合は面接情報が公開されません。"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", { staticClass: "boss-text margin-top-0 margin-bottom-1" }, [
        _vm._v("応募者のみに表示されます。"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "medium-3 cell  pega-pd-15  pega-interview-form-label" },
      [_c("span", [_vm._v("面接の選考情報")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "medium-3 cell pega-form-label pega-form-label-interview-top",
        attrs: { "data-test": "form-label" },
      },
      [_c("span", [_vm._v("面接官について")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "medium-3 cell  pega-pd-15  pega-interview-form-label" },
      [
        _c("span", [
          _vm._v("重視するポイント"),
          _c("br"),
          _vm._v(" "),
          _c("small", [_vm._v("「★」が多いほど重視するポイントとなります。")]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "medium-3 cell  pega-pd-15  pega-interview-form-label pega-interview-form-label-bottom",
      },
      [_c("span", [_vm._v("中途面接について")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }